import { Navigate, useLocation } from 'react-router-dom';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { ModulePackageBoundary } from '@platform/modularity';
import { canonicalModulePath } from '@platform/navigation';
import { useGetCatalogQuery } from '@platform/state/api';

/**
 * Межа маршрутів модуля `/:group/:module/*` (ADR-028): адреса з іншою групою чи ключем сутності замість slug замінюється канонічною
 * (canonicalModulePath), інакше — пакет модуля (ModulePackageBoundary) і його сторінки. Каталог простору (кеш) перерендерює межу, щойно
 * стануть відомі власні модулі (ADR-025), — адреса власного модуля зі старою групою теж стає канонічною.
 */
export function ModuleRoute() {
  const { pathname, search, hash } = useLocation();
  const { ws } = useWorkspaceParams();
  useGetCatalogQuery({ workspaceId: ws }, { skip: !ws });
  const canonical = canonicalModulePath(pathname);
  return canonical ? <Navigate to={`${canonical}${search}${hash}`} replace /> : <ModulePackageBoundary />;
}
